import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import AdminView from '../views/AdminView.vue'
import LoginView from '../views/LoginView.vue'
import store from "@/store";
import RegisterView from "@/views/RegisterView.vue";
import OrderView from "@/views/OrderView.vue";
import OrdersView from "@/views/OrdersView.vue";

const routes = [
    {
        path: '/',
        name: 'home',
        component: HomeView,
        meta: {
            requiresAuth: true,
            title: 'Список замовлень'
        }
    },
    {
        path: '/order/:id',
        name: 'Order',
        component: OrderView,
        meta: {
            requiresAuth: true,
            title: 'Замовлення '
        }
    },
    {
        path: '/orders',
        name: 'Orders',
        component: OrdersView,
        meta: {
            requiresAuth: true,
            title: 'Список замовлень'
        }
    },
    {
        path: '/draftsmen-stats',
        name: 'DraftsmenStats',
        component: () => import('../views/DraftsmenStatsView.vue'),
        meta: {
            requiresAuth: true,
            isAdmin: true,
            title: 'Статистика складальників'
        }
    },
    {
        path: '/adminpanel',
        component: AdminView,
        meta: {
            requiresAuth: true,
            isAdmin: true,
            allowDistributor: true,
            title: 'Панель адміністратора'
        }
    },
    {
        path: '/login',
        name: 'login',
        component: LoginView,
        meta: {
            requiresAuth: false,
            title: 'Вхід'
        }
    },
    {
        path: '/register',
        name: 'register',
        component: RegisterView,
        meta: {
            requiresAuth: false,
            title: 'Реєстрація'
        }
    }
]

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes
})

router.beforeEach(async (to, from, next) => {
    document.title = to.meta.title + " - patterns BRAWIX" || 'CRM - patterns BRAWIX ';

    const requiresAuth = to.matched.some(record => record.meta.requiresAuth);
    const requiresAdmin = to.matched.some(record => record.meta.isAdmin);
    const allowDistributor = to.matched.some(record => record.meta.allowDistributor);

    const isLoggedIn = store.getters.isLoggedIn;
    const isAdmin = store.getters.isAdmin;
    const isDistributor = store.getters.isDistributor;

    const hasAccessToAdminRoutes = isAdmin || (allowDistributor && isDistributor);

    if (requiresAuth && isLoggedIn && !store.state.isInitialDataLoaded) {
        try {
            await Promise.all([
                store.dispatch('fetchUserData'),
                store.dispatch('fetchStatuses')
            ]);

            const updatedIsAdmin = store.getters.isAdmin;
            const updatedIsDistributor = store.getters.isDistributor;
            const updatedHasAccess = updatedIsAdmin || (allowDistributor && updatedIsDistributor);

            if (requiresAdmin && !updatedHasAccess) {
                next('/');
            } else {
                next();
            }
        } catch (error) {
            await store.dispatch('logout');
            next('/login');
        }
    } else if (requiresAuth && !isLoggedIn) {
        next('/login');
    } else if (requiresAdmin && isLoggedIn && !hasAccessToAdminRoutes) {
        next('/');
    } else {
        next();
    }
});

export default router
